import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import {
  getFlightDetailsByFilter,
  getFlyingPageFilters,
  getLoading
} from '../../redux/selectors/flyingPage';
import FlightListDateDivider from './FlightListDateDivider';
import { getTimezone } from '../../redux/selectors/userData';
import { fromTimestamp } from '../../helpers/formatTime';
import { FlightDetailItemContainer } from './FlightDetailItemContainer';

function dateChanged(
  previousTimeStamp: number,
  currentTimeStamp: number,
  timezone: string
): boolean {
  const previousLocalMomentInTimezone = fromTimestamp(previousTimeStamp).tz(timezone);
  const currentLocalMomentInTimezone = fromTimestamp(currentTimeStamp).tz(timezone);
  return !previousLocalMomentInTimezone.isSame(currentLocalMomentInTimezone, 'day');
}
const FlightList: React.FC = () => {
  const isLoading = useSelector(getLoading);
  const filters = useSelector(getFlyingPageFilters);
  const flightDetails = useSelector(useSelector(state => getFlightDetailsByFilter(state, filters)));
  const sortedFlightDetails = [...flightDetails].sort(
    (a, b) => b.track.departedTime - a.track.departedTime
  );
  const timezone = useSelector(getTimezone);

  return (
    <div className="flight-detail-list">
      {isLoading && <Spin className="flight-detail-list-loading" />}
      {!isLoading &&
        sortedFlightDetails.map((flightDetail, index, flightList) => {
          const previousFlightDetail = index > 0 ? flightList[index - 1] : undefined;
          const hasDateChanged =
            previousFlightDetail === undefined
              ? true
              : dateChanged(
                  previousFlightDetail.track.departedTime,
                  flightDetail.track.departedTime,
                  timezone
                );

          return (
            <div key={`${flightDetail.aircraftId}-${flightDetail.track.departedTime}`}>
              {hasDateChanged && (
                <FlightListDateDivider timestamp={flightDetail.track.departedTime} />
              )}
              <FlightDetailItemContainer aircraftId={flightDetail.aircraftId} />
            </div>
          );
        })}
      {!isLoading && !sortedFlightDetails.length && (
        <div className="flight-detail-list-empty">No flights found</div>
      )}
    </div>
  );
};

export default FlightList;
